import IconButton from "@mui/material/Button";
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import {Button, DialogContent, FormControlLabel, FormGroup, TextField} from "@mui/material";
import * as React from "react";
import SettingsIcon from '@mui/icons-material/Settings';
import {useState} from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import Checkbox from '@mui/material/Checkbox';
import InputLabel from "@mui/material/InputLabel";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {FxmsData} from "../../../datas/FxData";

export const ChartDataMart = (props) => {
    const [open, setOpen] = useState(false)
    const [bgColor, setBgColor] = useState('#030000')
    const [alpha, setAlpha] = useState(99)
    const [value, setValue] = useState(0);
    const [api, setApi] = useState('')
    const handleCloseAndSave = () => {
        setOpen(false)
        props.handleCloseAndSave()
    }

    const handleColor = (e) => {
        let value = e.target.value
        setBgColor(value)
        // props.bgColor(value+alpha)
        props.options.setDesignOptions({...props.options.designOptions,bgColor:value+alpha})

    }
    const handleAlpha = (e) => {
        let value = e.target.value.toString(16).padStart(2, "0")
        setAlpha(value)
        // props.bgColor(bgColor+value)
        props.options.setDesignOptions({...props.options.designOptions,bgColor:bgColor+value})

    }
    const handleColors = (index,e) => {
        let base = props.options.designOptions.colors
        base[index] = e.target.value
        props.options.setDesignOptions({...props.options.designOptions,colors:base})
    }
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div>
            <IconButton size={'small'} sx={{minWidth:0, right:'35px',position:'absolute',zIndex:999}} onClick={()=>setOpen(true)}>
                <SettingsIcon/>
            </IconButton>
            <Dialog onClose={handleCloseAndSave} open={open}>
                <DialogTitle>제목 및 데이터 설정</DialogTitle>
                <DialogContent>
                    <Tabs value={value} onChange={handleChange}>
                        <Tab label="데이터 API" />
                        <Tab label="디자인 설정" />
                    </Tabs>
                    <CustomTabPanel value={value} index={0}>
                        <div>
                            <div>
                                API
                                <Button sx={{ml:10}} variant={"contained"} onClick={()=>{props.api(api)}}>실행</Button>
                            </div>
                            <TextField sx={{width:'600px',input:{color:'white'}, margin:'5px', '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                '.MuiSvgIcon-root ': {fill: "white !important",}}}
                               placeholder={"API"} value={api}
                               onChange={(e)=>setApi(e.target.value)} />
                        </div>
                        <div>
                            <Button sx={{m:1}} variant={"contained"} onClick={()=>{
                                setApi('h2/component/comp-selected-chart-values?endDate=20230706&moNo=10002&psId=UNDEF&psKindName=15M&startDate=20230706')
                            }}>h2 trend data sample</Button>
                            <Button sx={{m:1}} variant={"contained"} onClick={()=>{
                                setApi('http://175.123.142.155:11880/cemsTreeChartData')
                            }}> 트리차트 데이터 샘플</Button>
                            <Button sx={{m:1}} variant={"contained"} onClick={()=>{
                                setApi('http://175.123.142.155:11880/cemsEnergyUsageChartData')
                            }}> 에너지 사용량 바챠트</Button>
                            <Button sx={{m:1}} variant={"contained"} onClick={()=>{
                                setApi('http://175.123.142.155:11880/cemsEquipTypeChartData')
                            }}> 장비별 에너지 사용량 바챠트</Button>
                            <Button sx={{m:1}} variant={"contained"} onClick={()=>{
                                setApi('http://175.123.142.155:11880/cemsPieChart')
                            }}> 공정별 에너지 파이챠트</Button>
                            <Button sx={{m:1}} variant={"contained"} onClick={()=>{
                                setApi('http://175.123.142.155:11880/cemsRealtimeChart')
                            }}> 실시간 에너지 복합챠트</Button>

                        </div>

                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                        <div style={{fontSize:'medium'}}>
                            제목
                            <TextField sx={{input:{color:'white'}, margin:'15px', '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                '.MuiSvgIcon-root ': {fill: "white !important",}}} placeholder={"set chart title"} onChange={(e)=>{props.options.setDesignOptions({...props.options.designOptions,title:e.target.value})}} value={props.options.designOptions.title} />
                            소제목
                            <TextField sx={{input:{color:'white'}, margin:'15px', '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                '.MuiSvgIcon-root ': {fill: "white !important",}}} placeholder={"set chart subtitle"} onChange={(e)=>{props.options.setDesignOptions({...props.options.designOptions,subTitle:e.target.value})}} value={props.options.designOptions.subTitle}/>
                            <div>
                                <div>배경색 및 투명 설정</div>
                                <input id="color_picker" onInput={handleColor} type="color" value={bgColor} />
                                <input id="color_picker_alpha" onInput={handleAlpha} type="range" min="0" max="99" step="1" value={alpha}/>
                                <TextField sx={{input:{color:'white'}, margin:'15px', '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '.MuiSvgIcon-root ': {fill: "white !important",}}}
                                   placeholder={"bg color"} value={props.options.designOptions.bgColor}
                                           onChange={(e)=>{props.options.setDesignOptions({...props.options.designOptions,bgColor:e.target.value})}} />
                            </div>
                            <div>
                                <div>축 및 라벨 색상 설정</div>
                                x축 <input onInput={(e)=>{props.options.setDesignOptions({...props.options.designOptions,xColor:e.target.value})}} type="color" value={props.options.designOptions.xColor}  />
                                y축 <input onInput={(e)=>{props.options.setDesignOptions({...props.options.designOptions,yColor:e.target.value})}} type="color"  value={props.options.designOptions.yColor} />
                                그리드 <input onInput={(e)=>{props.options.setDesignOptions({...props.options.designOptions,glColor:e.target.value})}} type="color" value={props.options.designOptions.glColor}  />
                                <FormGroup style={{display:'block'}} >
                                    <FormControlLabel style={{float:'left'}} control={<Checkbox onChange={(e)=>{props.options.setDesignOptions({...props.options.designOptions,xGridlineWidth:e.target.checked?1:0})}} defaultChecked value={true} />} label="X grid" />
                                    <FormControlLabel style={{float:'left'}} control={<Checkbox onChange={(e)=>{props.options.setDesignOptions({...props.options.designOptions,yGridlineWidth:e.target.checked?1:0})}} defaultChecked value={true}/>} label="Y grid" />
                                </FormGroup>
                                <br/>
                                라벨 <input onInput={(e)=>{props.options.setDesignOptions({...props.options.designOptions,labelColor:e.target.value})}} type="color" value={props.options.designOptions.labelColor} />
                            </div>
                            <div>
                                <div>데이터 색상</div>
                                <div>
                                    <input style={{width:'50px'}} onInput={handleColors.bind(0,0)} type="color" value={props.options.designOptions.colors[0]} />
                                    <input style={{width:'50px'}} onInput={handleColors.bind(1,1)} type="color" value={props.options.designOptions.colors[1]} />
                                    <input style={{width:'50px'}} onInput={handleColors.bind(2,2)} type="color" value={props.options.designOptions.colors[2]} />
                                    <input style={{width:'50px'}} onInput={handleColors.bind(3,3)} type="color" value={props.options.designOptions.colors[3]} />
                                    <input style={{width:'50px'}} onInput={handleColors.bind(4,4)} type="color" value={props.options.designOptions.colors[4]} />
                                    <input style={{width:'50px'}} onInput={handleColors.bind(5,5)} type="color" value={props.options.designOptions.colors[5]} />
                                    <input style={{width:'50px'}} onInput={handleColors.bind(6,6)} type="color" value={props.options.designOptions.colors[6]} />
                                    <input style={{width:'50px'}} onInput={handleColors.bind(7,7)} type="color" value={props.options.designOptions.colors[7]} />
                                    <input style={{width:'50px'}} onInput={handleColors.bind(8,8)} type="color" value={props.options.designOptions.colors[8]} />
                                    <input style={{width:'50px'}} onInput={handleColors.bind(9,9)} type="color" value={props.options.designOptions.colors[9]} />
                                </div>
                            </div>
                            <div style={{marginTop:'15px'}}>
                                <FormControl sx={{m:'5px'}}>
                                    <InputLabel>챠트 타입</InputLabel>
                                    <Select style={{color:'white'}}
                                            value={props.options.designOptions.chartType}
                                            label="chart type"
                                            onChange={(e)=>{props.options.setDesignOptions({...props.options.designOptions,chartType:e.target.value})}}
                                    >
                                        <MenuItem style={{color:'white'}} value={"line"}>line</MenuItem>
                                        <MenuItem style={{color:'white'}} value={"spline"}>spline</MenuItem>
                                        <MenuItem style={{color:'white'}} value={"area"}>area</MenuItem>
                                        <MenuItem style={{color:'white'}} value={"areaspline"}>areaspline</MenuItem>
                                        <MenuItem style={{color:'white'}} value={"bar"}>bar</MenuItem>
                                        <MenuItem style={{color:'white'}} value={"column"}>column</MenuItem>
                                        <MenuItem style={{color:'white'}} value={"scatter"}>scatter</MenuItem>
                                        <MenuItem style={{color:'white'}} value={"pie"}>pie</MenuItem>
                                        <MenuItem style={{color:'white'}} value={"bubble"}>bubble</MenuItem>
                                        <MenuItem style={{color:'white'}} value={"packedbubble"}>packedbubble</MenuItem>
                                        <MenuItem style={{color:'white'}} value={"heatmap"}>heatmap</MenuItem>
                                        <MenuItem style={{color:'white'}} value={"treemap"}>treemap</MenuItem>
                                        <MenuItem style={{color:'white'}} value={"tilemap"}>tilemap</MenuItem>

                                    </Select>
                                </FormControl>
                                <FormControl sx={{m:'5px'}}>
                                    <InputLabel>stack 타입</InputLabel>
                                    <Select style={{color:'white'}}
                                            value={props.options.designOptions.stacking}
                                            label="chart type"
                                            onChange={(e)=>{props.options.setDesignOptions({...props.options.designOptions,stacking:e.target.value})}}
                                    >
                                        <MenuItem style={{color:'white'}} value={''}>don't stack</MenuItem>
                                        <MenuItem style={{color:'white'}} value={"normal"}>normal</MenuItem>
                                        <MenuItem style={{color:'white'}} value={"percent"}>percent</MenuItem>
                                    </Select>
                                </FormControl>
                                <FormControl sx={{m:'5px'}}>
                                    <InputLabel>x축 타입</InputLabel>
                                    <Select style={{color:'white'}}
                                            value={props.options.designOptions.xType}
                                            label="x type"
                                            onChange={(e)=>{props.options.setDesignOptions({...props.options.designOptions,xType:e.target.value})}}
                                    >
                                        <MenuItem style={{color:'white'}} value={"linear"}>linear</MenuItem>
                                        <MenuItem style={{color:'white'}} value={"logarithmic"}>logarithmic</MenuItem>
                                        <MenuItem style={{color:'white'}} value={"datetime"}>datetime</MenuItem>
                                        <MenuItem style={{color:'white'}} value={"category"}>category</MenuItem>

                                    </Select>
                                </FormControl>
                                <FormControl sx={{m:'5px'}}>
                                    <InputLabel>y축 타입</InputLabel>
                                    <Select style={{color:'white'}}
                                            value={props.options.designOptions.yType}
                                            label="x type"
                                            onChange={(e)=>{props.options.setDesignOptions({...props.options.designOptions,yType:e.target.value})}}
                                    >
                                        <MenuItem value={"linear"}>linear</MenuItem>
                                        <MenuItem value={"logarithmic"}>logarithmic</MenuItem>
                                        <MenuItem value={"datetime"}>datetime</MenuItem>
                                        <MenuItem value={"category"}>category</MenuItem>
                                        <MenuItem value={"treegrid"}>treegrid(Gantt charts)</MenuItem>

                                    </Select>
                                </FormControl>
                            </div>
                            <div style={{marginTop:'15px'}}>
                                <FormControl sx={{m:'5px'}}>
                                    <InputLabel>범례 위치</InputLabel>
                                    <Select style={{color:'white'}}
                                            value={props.options.designOptions.legendEnabled || props.options.designOptions.legendEnabled == 'false' ? props.options.designOptions.legendAlign : "disable"}
                                            label="legend align"
                                            onChange={(e)=>{
                                                e.target.value == "disable" ? props.options.setDesignOptions({...props.options.designOptions,legendEnabled:false}) :
                                                    props.options.setDesignOptions({...props.options.designOptions,legendEnabled:'true',legendAlign:e.target.value})
                                            }}
                                    >
                                        <MenuItem style={{color:'white'}} value={"left"}>left</MenuItem>
                                        <MenuItem style={{color:'white'}} value={"center"}>center</MenuItem>
                                        <MenuItem style={{color:'white'}} value={"right"}>right</MenuItem>
                                        <MenuItem style={{color:'white'}} value={"disable"}>disable</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                    </CustomTabPanel>

                </DialogContent>
            </Dialog>
        </div>

    )
}

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}